import { render, staticRenderFns } from "./CollectionViewMobile.vue?vue&type=template&id=6a76759a&scoped=true&"
import script from "./CollectionViewMobile.vue?vue&type=script&lang=js&"
export * from "./CollectionViewMobile.vue?vue&type=script&lang=js&"
import style0 from "./CollectionViewMobile.vue?vue&type=style&index=0&id=6a76759a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a76759a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
